import { AdminPreferences } from "@amzn/ask-legal-domain";
import * as React from "react";
import { useInstanceById } from "../../contexts/InstanceDataContext";
import { SearchInputBarV2 } from "../search/SearchInputBarV2";
import { PreferenceSelectionModal } from "../instance/PreferenceSelectionModal";
import { AppNavigationHeader } from "../navigation/AppNavigationHeader";
import { AppURLFactory } from "../../factory/app-url-factory";
import { AppHeaderProps } from "./AppHeader";
import "../../styles/component/layout/AppHeader.scss";
import "../../styles/component/layout/AppHeaderV2.scss";
const APP_LOGO: string = require("../../assets/pathfinder-logo-bw-new.png").default;
const AWS_LEGAL_LOGO: string = require("../../assets/aws-legal-logo-wb.png").default;
const AMAZON_LEGAL_LOGO: string = require("../../assets/amazon-legal-logo-wb.png").default;

export const AppHeaderV2 = (props: AppHeaderProps) => {
    const { instance, isLoading: loadingInstance } = useInstanceById(props.instanceId);
    const [preferenceSelectionModalProps, setPreferenceSelectionModalProps] =
        React.useState<React.ComponentProps<typeof PreferenceSelectionModal>>();
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);

    // Navigate to new home page when user is on instance homepage, otherwise stay on instance
    const logoHref = AppURLFactory.getHome(
        props.headerType === "Home" ? undefined : props.instanceId
    );

    const getOrganizationLogo = (org: AdminPreferences.Organization) => {
        switch (org) {
            case AdminPreferences.Organization.AMAZON_LEGAL:
                return AMAZON_LEGAL_LOGO;
            case AdminPreferences.Organization.AWS_LEGAL:
            default:
                return AWS_LEGAL_LOGO;
        }
    };

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    const handlePreferenceSelection = () => {
        setPreferenceSelectionModalProps({
            onDismiss: () => setPreferenceSelectionModalProps(undefined)
        });
    };

    return <>
        <nav className="app-navigation pf-agentic-header" aria-label="PathFinder">
            <div className={`nav-container${isMenuOpen ? " active" : ""}`}>
                <div className="nav-left">
                    <a href={logoHref}>
                        <img src={APP_LOGO} alt="Pathfinder" className="app-logo" draggable={false} />
                    </a>
                </div>

                {instance?.name && <div className={`nav-center${isMenuOpen ? " active" : ""}`}>
                    <button
                        type="button"
                        className="nav-instance-name-action pf-instance-pill"
                        title="Click here to access other legal orgs"
                        onClick={handlePreferenceSelection}
                    >
                        {instance.name}
                    </button>
                    <AppNavigationHeader instanceId={props.instanceId} isMenuOpen={isMenuOpen} />
                </div>}

                {instance?.preferences?.organization && <div className="nav-right">
                    {props.headerType !== "Home" && <span className="nav-search-bar">
                        <SearchInputBarV2
                            instanceId={props.instanceId}
                            disabled={loadingInstance}
                        />
                    </span>
                    }
                    <img
                        src={getOrganizationLogo(instance.preferences.organization)}
                        alt="Org Logo"
                        className="org-logo"
                        draggable={false}
                    />
                </div>}

                {instance?.name && <button
                    type="button"
                    className="nav-hamburger"
                    aria-label={isMenuOpen ? "Close menu" : "Open menu"}
                    aria-expanded={isMenuOpen}
                    onClick={toggleMenu}
                >
                    <span></span>
                    <span></span>
                    <span></span>
                </button>}
            </div>
        </nav>
        {preferenceSelectionModalProps && <PreferenceSelectionModal {...preferenceSelectionModalProps} />}
        <div className="pf-agentic-header-spacer" aria-hidden="true" />
    </>;
};
